import React from 'react';
import PropTypes from 'prop-types';

function currencyCell({ cell: { value: initialValue } }) {
  const value = initialValue.toFixed(2);

  return <div>${value}</div>;
}

currencyCell.propTypes = {
  cell: PropTypes.object,
};

export default currencyCell;
